import { render, staticRenderFns } from "./admin-kpi-type-tab.vue?vue&type=template&id=586e7f46&scoped=true"
import script from "./admin-kpi-type-tab.vue?vue&type=script&lang=ts"
export * from "./admin-kpi-type-tab.vue?vue&type=script&lang=ts"
import style0 from "./admin-kpi-type-tab.vue?vue&type=style&index=0&id=586e7f46&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e7f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586e7f46')) {
      api.createRecord('586e7f46', component.options)
    } else {
      api.reload('586e7f46', component.options)
    }
    module.hot.accept("./admin-kpi-type-tab.vue?vue&type=template&id=586e7f46&scoped=true", function () {
      api.rerender('586e7f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/data-management/tabs/admin-kpi-type-tab.vue"
export default component.exports